import { fontXSStyle, panelBaseStyle } from '@blocksuite/affine-shared/styles';
import { css } from 'lit';

export const renameStyles = css`
  ${panelBaseStyle('.affine-attachment-rename-container')}
  .affine-attachment-rename-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 320px;
    gap: 12px;
    padding: 12px;
    z-index: var(--streamlain-z-index-popover);
  }

  .affine-attachment-rename-input-wrapper {
    display: flex;
    min-width: 280px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 10px;
    background: var(--streamlain-white-10);
    border-radius: 4px;
    border: 1px solid var(--streamlain-border-color);
  }

  .affine-attachment-rename-input-wrapper:focus-within {
    border-color: var(--streamlain-blue-700);
    box-shadow: var(--streamlain-active-shadow);
  }

  .affine-attachment-rename-input-wrapper input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    color: var(--streamlain-text-primary-color);
  }
  ${fontXSStyle('.affine-attachment-rename-input-wrapper input')}

  .affine-attachment-rename-input-wrapper input::placeholder {
    color: var(--streamlain-placeholder-color);
  }

  .affine-attachment-rename-extension {
    font-size: var(--streamlain-font-xs);
    color: var(--streamlain-text-secondary-color);
  }

  .affine-attachment-rename-overlay-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: var(--streamlain-z-index-popover);
  }
`;

export const styles = css`
  :host {
    z-index: 1;
  }
`;
